// HAPPYCAP_AUTH_MOBILE_COMPACT_V1
// HAPPYCAP_AUTH_TYPO_UNIFIED_V1
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function ResetPasswordRequest() {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const mainRef = useRef(null);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, []);

  const handleSubmit = async () => {
    try {
      await axios.post("/api/auth/request-reset/", {
        email,
        language: i18n.language,
      });
      setMsg(t("reset.success"));
    } catch (err) {
      setMsg(t("reset.error"));
    }
  };

  return (
    <main
      ref={mainRef}
      role="main"
      tabIndex={-1}
      aria-label={t("reset.title")}
      className="w-[calc(100%-2.5rem)] max-w-sm sm:max-w-md mx-auto mt-8 sm:mt-10 mb-10 bg-white border border-white/80 shadow-[0_16px_55px_rgba(22,63,99,0.09)] rounded-[24px] p-5 sm:p-9"
    >
      <h2 className="text-2xl sm:text-4xl font-bold tracking-tight mb-7 text-center text-[#163F63]" id="reset-title">
        {t("reset.title")}
      </h2>

      <label htmlFor="email" className="sr-only">
        {t("reset.placeholder")}
      </label>
      <input
        id="email"
        type="email"
        placeholder={t("reset.placeholder")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full border border-slate-300 bg-white px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#247BA8] mb-4"
        aria-describedby="reset-title"
      />

      <button
        onClick={handleSubmit}
        className="w-full border-2 border-orange-400 bg-transparent text-orange-500 hover:bg-orange-50 font-semibold py-3 rounded-xl shadow-sm hover:shadow-md transition-all duration-200"
        aria-label={t("reset.button")}
      >
        {t("reset.button")}
      </button>

      {msg && (
        <p
          className="mt-4 text-center text-sm"
          role="status"
          aria-live="polite"
        >
          {msg}
        </p>
      )}
    </main>
  );
}
